<template>
  <basicContainer>
    <div class="yytbgl">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="待结算" name="1"></el-tab-pane>
        <el-tab-pane label="已结算" name="2"></el-tab-pane>
      </el-tabs>
      <!-- 预约填报管理 -->
      <avue-crud
        :data="data"
        :option="option"
        :page.sync="page"
        @on-load="onLoad"
        :search.sync="search"
        @search-change="searchChange"
        @search-reset="searchReset"
        @refresh-change="refreshChange"
        @selection-change="selectionChange"
      >
      <template slot="menuLeft">
        <el-button type="primary" size="small" @click="payFun">{{this.exdataTitel}}</el-button>
      </template>
      </avue-crud>
    </div>
  </basicContainer>
</template>

<script>
import { dateFormat } from '@/framework/util/date'
export default {
  data() {
    return {
      activeName: '1',
      hide: '',
      exdataTitel: '结算',
      formid: '', // 流程表单ID
      data: [],
      option: {
        dialogDrag: true,
        dialogClickModal: false,
        stripe: true,
        border: true,
        page: true,
        selection: true,
        align: 'left',
        menuAlign: 'center',
        menuWidth: 80,
        searchMenuSpan: 24,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 150,
        viewBtn: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        // searchSize: 'medium',
        column: [
          {
            label: '项目名称',
            prop: 'xmmc'
          },
          {
            label: '出差事由',
            prop: 'ccsy'
          },
          {
            label: '实际出发地',
            prop: 'cfcs',
            search: true,
            searchLabelWidth: 110
          },
          {
            label: '实际目的地',
            prop: 'ddcs',
            search: true,
            searchLabelWidth: 110
          },
          {
            label: '行程日期',
            prop: 'ydrq'

          },
          {
            label: '代订费（元）',
            prop: 'jpjg',
            search: true,
            searchLabelWidth: 110
          },
          //   {
          //     label: '创建人',
          //     prop: 'create_user',
          //     search: true,
          //     hide: true
          //   },
          {
            label: '申请人',
            prop: 'sqr',
            search: true
          }

        ]
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        pageSizes: [10, 20, 30, 40, 50, 100],
        total: 0
      },
      search: {},
      tab: 1,
      ids: [],
      select_list: []
    }
  },

  methods: {
    payFun: function() {
      if (this.activeName == '1') {
        if (this.ids.length == 0 || this.ids.split(',').length == 0) {
          this.$message.error('请至少选择一条需要结算的数据')
          return
        }
        this.$http
          .post('/AirTicketBookingManage/insertSettlement', this.ids.split(','))
          .then(res => {
            this.$message.success(res.msg)
            // this.load()
            this.$downloadFile.post('/tickets/dataExport', this.select_list, {
              params: {
                doDownload: true,
                fileName: '结算报销单_' + dateFormat(new Date(), 'yyyy-MM-dd') + '.xlsx'
              }
            }).then(res => {
              this.load()
            })
              .catch(error => {
                this.$message.error(error.msg || error.message)
              })
          })
          .catch(error => {
            this.$message.error(error.msg || error.message)
          })
      } else {
        this.$downloadFile.post('/tickets/dataExport', this.select_list, {
          params: {
            doDownload: true,
            fileName: '结算报销单_' + dateFormat(new Date(), 'yyyy-MM-dd') + '.xlsx'
          }
        }).then(res => {
          this.load()
        })
          .catch(error => {
            this.$message.error(error.msg || error.message)
          })
      }
    },
    selectionChange(list) {
      this.ids = list.map((item) => item.id).join(',')
      this.select_list = list
    },
    load(done) {
      this.search.status = this.tab
      this.$http
        .post('/AirTicketBookingManage/query', { ...this.search }, {
          params: {
            pageNum: this.page.currentPage,
            pageSize: this.page.pageSize

          }
        })
        .then(res => {
          this.data = res.data.records || []
          this.page.total = res.data.total || res.data.records.length || 0
        })
        .catch(error => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          typeof done === 'function' && done()
        })
    },
    handleClick(tab, event) {
      if (tab.name == '1') {
        this.exdataTitel = '结算'
      } else {
        this.exdataTitel = '导出'
      }
      this.tab = tab.name
      this.load()
    },
    onLoad(page) {
      this.page.currentPage = page.currentPage
      this.page.pageSize = page.pageSize
      this.load()
    },
    searchChange(params, done) {
      if (params.htqd !== undefined) {
        params.htqd = params.htqd.toString()
      }

      if (params.updatetime !== undefined) {
        params.updatetime = params.updatetime.toString()
      }
      this.search = params
      this.page.currentPage = 1
      this.load(done)
    },
    searchReset() {
      this.search = {}
      this.page.currentPage = 1
      this.load()
    },
    refreshChange() {
      this.load()
    }

  }
}
</script>

<style>
.hide {
  display: none;
}
</style>
